import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=f0e432d2&scoped=true"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=f0e432d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e432d2",
  null
  
)

export default component.exports